import { ready } from 'brei-project-utils';

import { animator } from './modules/animator.js';
import { tabcordion } from './modules/tabcordion';

// Example of importing a custom module
// import { primaryNav } from './modules/primaryNav';

const landing = {

	init() {
		animator.init();
		tabcordion.init();
	},

};

ready(function () {
	landing.init();
});
